import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { Toaster } from "sonner";
import { auth } from "./lib/api";
import { MenuProvider } from "./lib/MenuContext";

function RequireAuth({ children }) {
  if (!auth.getToken()) return <Navigate to="/login" replace />;
  return (
    <MenuProvider>
      {children}
    </MenuProvider>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          style: {
            background: "#FFFCF5",
            border: "1px solid #E6E2D8",
            color: "#1A1918",
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
    </>
  );
}

export default App;
